
import moment from "moment";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import cities from '../../Data/Cities.json';
import { Link, useNavigate } from 'react-router-dom';
import React, { useState, useEffect, useRef, useContext } from 'react';
import { LandingContext } from '../Profile/LandingContext';
import DefaultData from "../../CompanyData/DefaultData";

const HotelSearchPanel = () => {
    const navigate = useNavigate();
    const landingData = useContext(LandingContext);
    const [isDomestic, setIsDomestic] = useState('INTERNATIONAL');
    const [roomInfo, setRoomInfo] = useState([
        {
            adults: 1,
            kids: 1,
            kidsAge: [2],
            adultsFields: [{ title: "Mr", firstName: "", lastName: "", travelerType: "ADULT", dateOfBirth: new Date(), panCard: "", passportNo: "", passportNationality: "", passbookIssueDate: new Date(), passbookExpireDate: new Date() }],
            kidsFields: [{ title: "Miss", firstName: "", lastName: "", travelerType: "CHILD", dateOfBirth: new Date(), panCard: "", passportNo: "", passportNationality: "", passbookIssueDate: new Date(), passbookExpireDate: new Date() }]
        }
    ]);

    const handleChildAgeChange = (roomIndex, childIndex, value) => {
        const updatedRoomInfo = [...roomInfo];
        updatedRoomInfo[roomIndex].kidsAge[childIndex] = value;
        setRoomInfo(updatedRoomInfo);
    };

    const addRoom = (e) => {
        e.stopPropagation();
        setRoomInfo([
            ...roomInfo,
            {
                adults: 1,
                kids: 1,
                kidsAge: [2],
                adultsFields: [{ title: "Mr", firstName: "", lastName: "", travelerType: "ADULT", dateOfBirth: new Date(), panCard: "", passportNo: "", passportNationality: "", passbookIssueDate: "", passbookExpireDate: "" }],
                kidsFields: [{ title: "Miss", firstName: "", lastName: "", travelerType: "CHILD", dateOfBirth: new Date(), panCard: "", passportNo: "", passportNationality: "", passbookIssueDate: "", passbookExpireDate: "" }]
            }
        ]);
        setTotalRooms(parseInt(totalRooms + 1));
        setTotalAdults(parseInt(totalAdults + 1));
        setTotalKids(parseInt(totalKids + 1));
    };

    const deleteRoom = (e, index) => {
        e.stopPropagation();
        if (index !== 0) {
            const updatedRoomInfo = [...roomInfo];
            updatedRoomInfo.splice(index, 1);
            setRoomInfo(updatedRoomInfo);
            setTotalRooms(parseInt(totalRooms - 1));
            setTotalAdults(parseInt(totalAdults - 1));
            setTotalKids(parseInt(totalKids - 1));
        }
    };

    const [displayFrom, setDisplayFrom] = useState('DUBAI, DUBAI, UNITED ARAB EMIRATES');
    const [cityId, setCityId] = useState('147862');
    const [city, setCity] = useState('DUBAI');
    const [country, setCountry] = useState('UNITED ARAB EMIRATES');
    const [totalGuests, setTotalGuests] = useState(2);
    const [checkInDate, setCheckInDate] = useState(new Date());
    const [checkOutDate, setCheckOutDate] = useState(new Date());
    const [totalAdults, setTotalAdults] = useState(1);
    const [totalKids, setTotalKids] = useState(1);
    const [totalRooms, setTotalRooms] = useState(1);
    const [errors, setErrors] = useState({});
    const [cityResults, setCityResults] = useState([]);
    const inputCRef = useRef(null);

    const handleCitySearch = (e) => {
        const value = e.target.value;
        setDisplayFrom(value);
        if (value.length > 0) {
            const filteredCities = cities
                .filter(c =>
                    c.cityName.toLowerCase().includes(value.toLowerCase()) && c.type !== 'MULTI_CITY_VICINITY'
                )
                .slice(0, 10);
            setCityResults(filteredCities);
        } else {
            setCityResults([]);
        }
    };

    const handleCityClick = () => {
        const filteredCities = cities.slice(0, 10);
        setCityResults(filteredCities);
        inputCRef.current.select();
    };

    const handleCitySelect = (data) => {
        setIsDomestic(data.countryName !== "INDIA" ? 'INTERNATIONAL' : 'DOMESTIC');
        setDisplayFrom(data.fullRegionName);
        setCityId(data.id);
        setCity(data.cityName);
        setCountry(data.countryName);
        setCityResults([]);
    };

    const validate = () => {
        const temp = { displayFrom: displayFrom !== "" };
        setErrors(temp);
        return Object.values(temp).every(x => x === true);
    };

    const handleSearch = (e) => {
        e.preventDefault();
        if (validate()) {
            const searchQuery = {
                "cityCode": '' + cityId,
                "city": city,
                "displayFrom": displayFrom,
                "checkInDate": moment(checkInDate).format('YYYY-MM-DD'),
                "checkOutDate": moment(checkOutDate).format('YYYY-MM-DD'),
                "nationality": "106",
                "currency": "INR",
                "country": country,
                "rating": [3, 4, 5],
                "hotelRooms": roomInfo,
                "requestedBy": "CUSTOMER",
                "totalGuests": parseInt(totalAdults + totalKids),
                "totalAdults": totalAdults,
                "totalKids": totalKids,
                "totalRooms": totalRooms,
                "companyId": DefaultData?.DEFAULTCOMPANYID,
                "isDomestic": isDomestic
            };
            navigate('/hotels/', { state: { searchQuery } });
        }
    };

    const handleIncreaseAdults = (e, index, adultvalue) => {
        e.stopPropagation();
        if (adultvalue < 7) {
            const value = parseInt(adultvalue + 1);
            const updatedRoomInfo = [...roomInfo];
            updatedRoomInfo[index].adults = value;
            const avalues = [];
            for (let i = 0; i < value; i++) {
                avalues.push({ title: "Mr", firstName: "", lastName: "", travelerType: "ADULT", dateOfBirth: new Date(), panCard: "", passportNo: "", passportNationality: "", passbookIssueDate: new Date(), passbookExpireDate: new Date() });
            }
            updatedRoomInfo[index].adultsFields = avalues;
            setTotalAdults(parseInt(totalAdults + 1));
            setTotalGuests(parseInt(totalGuests + 1));
            setRoomInfo(updatedRoomInfo);
        }
    };

    const handleDecreaseAdults = (e, index, adultvalue) => {
        e.stopPropagation();
        if (adultvalue !== 1) {
            const value = parseInt(adultvalue - 1);
            const updatedRoomInfo = [...roomInfo];
            updatedRoomInfo[index].adults = value;
            const avalues = [];
            for (let i = 0; i < value; i++) {
                avalues.push({ title: "Mr", firstName: "", lastName: "", travelerType: "ADULT", dateOfBirth: new Date(), panCard: "", passportNo: "", passportNationality: "", passbookIssueDate: "", passbookExpireDate: "" });
            }
            updatedRoomInfo[index].adultsFields = avalues;
            setRoomInfo(updatedRoomInfo);
            setTotalAdults(parseInt(totalAdults - 1));
            setTotalGuests(parseInt(totalGuests - 1));
        }
    };

    const handleIncreaseKids = (e, index, kidvalue) => {
        e.stopPropagation();
        if (kidvalue < 4) {
            const value = parseInt(kidvalue + 1);
            const updatedRoomInfo = [...roomInfo];
            updatedRoomInfo[index].kids = value;
            updatedRoomInfo[index].kidsAge = new Array(value).fill(1);
            const avalues = [];
            for (let i = 0; i < value; i++) {
                avalues.push({ title: "Miss", firstName: "", lastName: "", travelerType: "CHILD", dateOfBirth: new Date(), panCard: "", passportNo: "", passportNationality: "", passbookIssueDate: "", passbookExpireDate: "" });
            }
            updatedRoomInfo[index].kidsFields = avalues;
            setRoomInfo(updatedRoomInfo);
            setTotalKids(parseInt(totalKids + 1));
            setTotalGuests(parseInt(totalGuests + 1));
        }
    };

    const handleDecreaseKids = (e, index, kidvalue) => {
        e.stopPropagation();
        if (kidvalue !== 0) {
            const value = parseInt(kidvalue - 1);
            const updatedRoomInfo = [...roomInfo];
            updatedRoomInfo[index].kids = value;
            updatedRoomInfo[index].kidsAge = new Array(value).fill(1);
            const avalues = [];
            for (let i = 0; i < value; i++) {
                avalues.push({ title: "Miss", firstName: "", lastName: "", travelerType: "CHILD", dateOfBirth: new Date(), panCard: "", passportNo: "", passportNationality: "", passbookIssueDate: "", passbookExpireDate: "" });
            }
            updatedRoomInfo[index].kidsFields = value === 0 ? [] : avalues;
            setRoomInfo(updatedRoomInfo);
            setTotalKids(parseInt(totalKids - 1));
            setTotalGuests(parseInt(totalGuests - 1));
        }
    };

    const handleCheckInDate = (date) => {
        const selectedDate = date[0];
        setCheckInDate(selectedDate);
        if (checkOutDate && selectedDate && checkOutDate < selectedDate) {
            const newDate = new Date(selectedDate.getTime());
            setCheckOutDate(newDate.setDate(newDate.getDate() + 1));
        }
    };

    const handleCheckOutDate = (date) => {
        const selectedDate = date[0];
        if (selectedDate !== null) {
            const newDate = new Date(selectedDate.getTime());
            if (moment(newDate).format('DD-MM-YYYY') <= moment(checkInDate).format('DD-MM-YYYY')) {
                setCheckOutDate(newDate.setDate(newDate.getDate() + 1));
            } else {
                setCheckOutDate(newDate.setDate(newDate.getDate()));
            }
        }
    };

    const addDays = (cdate) => {
        if (cdate === undefined) cdate = new Date();
        const newDate = new Date(cdate.getTime());
        setCheckOutDate(newDate.setDate(cdate.getDate() + 1));
    };

    useEffect(() => {
        addDays(checkInDate);
    }, []);

    const guestSummary = `${totalRooms} Room${totalRooms > 1 ? 's' : ''}, ${totalAdults} Adult${totalAdults > 1 ? 's' : ''}, ${totalKids} Child${totalKids !== 1 ? 'ren' : ''}`;

    return (
        <div className="hotel-search-bar">
            <div className="row gy-3 gx-lg-2 gx-3 align-items-end">

                {/* City / Destination */}
                <div className="col-lg-3 col-md-6 col-12">
                    <label className="hsp-label">CITY / DESTINATION</label>
                    <div className="hsp-input-wrap" style={{ position: "relative" }}>
                        <i className="ri-map-pin-line hsp-icon" />
                        <input
                            className="form-control"
                            type="text"
                            placeholder="Where are you going?"
                            value={displayFrom}
                            onChange={handleCitySearch}
                            onClick={handleCityClick}
                            onFocus={handleCityClick}
                            ref={inputCRef}
                        />
                        {errors.displayFrom === false && (
                            <div className="hsp-error">Please select a city</div>
                        )}
                        {cityResults.length > 0 && (
                            <div className="hsp-city-list">
                                {cityResults.map((cityItem) => (
                                    <div
                                        className="hsp-city-item"
                                        key={cityItem.id}
                                        onClick={() => handleCitySelect(cityItem)}
                                    >
                                        <div className="hsp-city-icon">
                                            <i className="ri-building-line" />
                                        </div>
                                        <div>
                                            <div className="hsp-city-main">{cityItem.cityName}</div>
                                            <div className="hsp-city-sub">{cityItem.fullRegionName}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                {/* Check-In */}
                <div className="col-lg-2 col-md-6 col-12">
                    <label className="hsp-label">CHECK-IN</label>
                    <div className="hsp-date-wrap">
                        <i className="ri-calendar-2-line hsp-date-icon" />
                        <Flatpickr
                            className="form-control"
                            name="checkInDate"
                            value={checkInDate}
                            onChange={(date) => handleCheckInDate(date)}
                            options={{ dateFormat: "d M Y", minDate: "today" }}
                        />
                    </div>
                </div>

                {/* Check-Out */}
                <div className="col-lg-2 col-md-6 col-12">
                    <label className="hsp-label">CHECK-OUT</label>
                    <div className="hsp-date-wrap">
                        <i className="ri-calendar-2-line hsp-date-icon" />
                        <Flatpickr
                            className="form-control"
                            name="checkOutDate"
                            value={checkOutDate}
                            onChange={(date) => handleCheckOutDate(date)}
                            options={{ dateFormat: "d M Y", minDate: checkInDate }}
                        />
                    </div>
                </div>

                {/* Rooms & Guests */}
                <div className="col-lg-3 col-md-6 col-12">
                    <label className="hsp-label">ROOMS & GUESTS</label>
                    <div className="dropdown" data-bs-auto-close="outside">
                        <div
                            className="hsp-input-wrap dropdown-toggle"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            style={{ cursor: "pointer" }}
                        >
                            <i className="ri-team-line hsp-icon" />
                            <input
                                className="form-control"
                                type="text"
                                readOnly
                                value={guestSummary}
                                style={{ cursor: "pointer" }}
                            />
                        </div>
                        <div className="hsp-rooms-menu dropdown-menu">
                            {roomInfo.map((room, index) => (
                                <div key={index} className="hsp-room-block">
                                    <div className="hsp-room-header">
                                        <span className="hsp-room-title">Room {index + 1}</span>
                                        {index !== 0 && (
                                            <button
                                                type="button"
                                                className="hsp-delete-room"
                                                onClick={(e) => deleteRoom(e, index)}
                                            >
                                                <i className="ri-delete-bin-line" /> Remove
                                            </button>
                                        )}
                                    </div>
                                    <div className="hsp-room-row">
                                        <div className="hsp-guest-group">
                                            <span className="hsp-guest-label">Adults</span>
                                            <div className="hsp-counter">
                                                <button
                                                    type="button"
                                                    onClick={(e) => handleDecreaseAdults(e, index, room.adults)}
                                                    disabled={room.adults <= 1}
                                                >−</button>
                                                <input type="number" readOnly value={room.adults} />
                                                <button
                                                    type="button"
                                                    onClick={(e) => handleIncreaseAdults(e, index, room.adults)}
                                                >+</button>
                                            </div>
                                        </div>
                                        <div className="hsp-guest-group">
                                            <span className="hsp-guest-label">Kids</span>
                                            <div className="hsp-counter">
                                                <button
                                                    type="button"
                                                    onClick={(e) => handleDecreaseKids(e, index, room.kids)}
                                                    disabled={room.kids <= 0}
                                                >−</button>
                                                <input type="number" readOnly value={room.kids} />
                                                <button
                                                    type="button"
                                                    onClick={(e) => handleIncreaseKids(e, index, room.kids)}
                                                >+</button>
                                            </div>
                                        </div>
                                    </div>
                                    {room.kidsAge.length > 0 && (
                                        <div className="hsp-kids-ages">
                                            {room.kidsAge.map((age, childIndex) => (
                                                <div key={childIndex} className="hsp-age-select">
                                                    <label>Child {childIndex + 1} Age</label>
                                                    <select
                                                        className="form-select"
                                                        value={age}
                                                        onChange={(e) => handleChildAgeChange(index, childIndex, parseInt(e.target.value))}
                                                    >
                                                        {[...Array(11)].map((_, i) => {
                                                            const val = i + 2;
                                                            return <option key={val} value={val}>{val}</option>;
                                                        })}
                                                    </select>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ))}
                            <div className="hsp-rooms-footer">
                                <button type="button" className="hsp-add-room" onClick={addRoom}>
                                    <i className="ri-add-line" /> Add Room
                                </button>
                                <button
                                    type="button"
                                    className="hsp-done-btn"
                                    onClick={(e) => { e.stopPropagation(); document.activeElement.blur(); }}
                                >
                                    Done
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Search */}
                <div className="col-lg-2 col-12">
                    <button type="button" className="hsp-search-btn" onClick={handleSearch}>
                        <i className="ri-search-line" /> Search Hotels
                    </button>
                </div>

            </div>
        </div>
    );
};

export default HotelSearchPanel;
